"use client";

import { useEffect, useState } from "react";
import { Dialog } from "./Dialog";
import { t } from "i18next";
import type { LatLngLiteral, LeafletMouseEvent, Map } from "leaflet";
import { Button } from "../ui";
import { MapIcon } from "lucide-react";
import { LeafletMap } from "../maps/leaflet-map.lazy";
import type { LocationPickerProps, OSMRes } from "~/types/ui";

export default function LocationPickerDialog({
  latitude,
  longitude,
  onChange,
}: LocationPickerProps) {
  const center: [number, number] =
    latitude != null && longitude != null ? [latitude, longitude] : [58, 14];
  const [dialog, setDialog] = useState(false);
  const [marker, setMarker] = useState<[number, number]>(center);

  function onLeafletClickHandler(_: Map, e: LeafletMouseEvent) {
    onChange?.({ lat: e.latlng.lat, lng: e.latlng.lng });
    setMarker([e.latlng.lat, e.latlng.lng]);
  }

  function onLocationSearchSelect(map: Map, res: OSMRes) {
    map.flyTo([parseFloat(res.lat), parseFloat(res.lon)], 17);
  }

  useEffect(() => {
    if (latitude != null && longitude != null) {
      setMarker([latitude, longitude]);
    }
  }, [latitude, longitude]);

  return (
    <Dialog
      title={t("map.selectLocation")}
      description={t("map.selectLocationDescription")}
      open={dialog}
      onOpenChange={setDialog}
      width="90vw"
      children={
        <>
          <LeafletMap
            center={center}
            zoom={7}
            markers={[marker]}
            onClick={onLeafletClickHandler}
            onLocationSearchSelect={onLocationSearchSelect}
          />

          <div className="mt-4 text-sm text-gray-500">
            Latitude: {marker.at(0) ?? "N/A"}, Longitude:{" "}
            {marker.at(1) ?? "N/A"}
          </div>
        </>
      }
      trigger={
        <Button variant="outline" onClick={() => setDialog(true)}>
          <MapIcon />
        </Button>
      }
    />
  );
}
